import { useDeviceType, Box, ErrorBoundary } from '@packages/shared';
import { DynamicSearchField } from './SearchField';
import { Slots } from './Slots';
import { LinkedLogo } from './LinkedLogo';

/** This component has the html header tag */
export const Toolbar = () => {
  const { isDesktop } = useDeviceType();

  return (
    <Box
      component="header"
      sx={{
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: [0, 0, 0, 6.5],
        px: [1, 1, 1, 0],
      }}
    >
      <LinkedLogo />
      {isDesktop && (
        <Box sx={{ flexGrow: 1 }}>
          <ErrorBoundary>
            <DynamicSearchField />
          </ErrorBoundary>
        </Box>
      )}
      <ErrorBoundary>
        <Slots />
      </ErrorBoundary>
    </Box>
  );
};
